import React, { useEffect, useRef, useState } from "react";
import SignatureCanvas from "react-signature-canvas";


const SignatureField = ({ value = "", onChange }) => {
  const sigCanvasRef = useRef(null);
  const containerRef = useRef(null);
  const [canvasWidth, setCanvasWidth] = useState(670);

  useEffect(() => {
    const updateCanvasWidth = () => {
      if (!containerRef.current) return;
      const nextWidth = Math.min(670, Math.floor(containerRef.current.offsetWidth));
      setCanvasWidth(nextWidth > 0 ? nextWidth : 670);
    };

    updateCanvasWidth();
    window.addEventListener("resize", updateCanvasWidth);
    return () => window.removeEventListener("resize", updateCanvasWidth);
  }, []);

  const clear = () => {
    sigCanvasRef.current.clear();
    onChange("");
  };

  const save = () => {
    if (!sigCanvasRef.current.isEmpty()) {
      const dataUrl = sigCanvasRef.current.getCanvas().toDataURL("image/png");
      onChange(dataUrl);
    }
  };

  return (
    <div ref={containerRef} style={{ width: "100%" }}>
      <SignatureCanvas
        key={canvasWidth}
        ref={sigCanvasRef}
        penColor="#fff"
        backgroundColor="#111827"
        canvasProps={{ width: canvasWidth, height: 200, className: "sigCanvas" }}
        onEnd={save}
      />
      <div style={{ marginTop: 8 }}>
        <button type="button" onClick={clear}>
          Clear
        </button>
      </div>
      {/* {value && (
        <div style={{ marginTop: 8 }}>
          <img
            src={value}
            alt="signature preview"
            style={{ border: "1px solid #ccc", width: "100%", maxHeight: 200 }}
          />
        </div>
      )} */}
    </div>
  );
};

  export default SignatureField